const matiasData = {
  experience: [
    {
      iconName: "RiUserHeartLine",
      text: "Matías Vinot, *Psicólogo Clínico* y *Psicoterapeuta,* con más de 5 años de experiencia atendiendo pacientes en consulta particular, desde el Enfoque Psicoterapéutico Posracionalista.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Psicólogo Educacional*, en el área de Convivencia Escolar.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Co - Docente y Supervisor Clínico* en el área de *formación clínica y psicoterapia* a psicólogos titulados, desde el Enfoque Posracionalista basado en la Fenomenología - Hermenéutica.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Experiencia académica* como ayudante en el ámbito de la *psicología clínica y psicoterapia.*",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Supervisor Clínico Particular*, en modalidad individual y grupal, a estudiantes en práctica profesional de la carrera de psicología y psicólogos titulados, impartiendo formación teórico - práctica, y supervisando casos clínicos, desde el Enfoque Posracionalista Fenomenológico - Hermenéutico.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Investigaciones científicas* en el área de psicología y creación de *artículos* de psicología clínica y psicoterapia.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Autor de los artículos* publicados en *revista “El Encuentro”*de la Universidad Autónoma de Chile: *“La importancia de la persona del terapeuta en el efecto de cambio en la identidad del paciente durante el proceso de psicoterapia” y “La implicancia de comprender el síntoma y realizar psicoterapia desde el paradigma de la complejidad”.*",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "Voluntario en *XXIII Congreso Nacional de Psicología Clínica*: “Temas emergentes en el siglo XXI”.",
    },
    {
      iconName: "TbAward",
      text: "Membresía *Colegio de Psicólogos de Chile A.G.*",
    },
    {
      iconName: "TbAward",
      text: "Membresía Sociedad Chilena de Psicología Clínica y Psicoterapia *(SCPC).*",
    },
    { iconName: "RiUserFollowLine", text: "Responsable y comprometido." },
    { iconName: "RiUserFollowLine", text: "Características de liderazgo." },
    {
      iconName: "RiUserFollowLine",
      text: "Participativo y con apertura a la experiencia.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Organización, planificación, metodología, coordinación e intervención.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Psicoterapia, psicodiagnóstico, evaluaciones psicológicas y psicoeducación.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Redacción de Informes.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Matías, inició un proceso de *psicoterapia personal*, hace aproximadamente dos años y medio, el cual continúa activo en la actualidad. Estudios demuestran que es de vital importancia que un psicólogo realice un trabajo personal, *“La Persona del Terapeuta”,* ya que influye directamente al momento de realizar mejor su trabajo clínico en la atención de pacientes y como una *práctica de autocuidado.*",
    },
  ],
  studies: [
    {
      iconName: "FaGraduationCap",
      text: "*Licenciado en Psicología y Titulado de Psicólogo* de la Universidad Autónoma de Chile, sede Providencia, Santiago de Chile *(Distinción Máxima).*",
    },
    {
      iconName: "FaGraduationCap",
      text: "Tesis Licenciatura: *“El efecto de la violencia, en el marco de los discursos heteronormativos sobre género, en la constitución de sujetos trans, un estudio cualitativo”.*",
    },
    {
      iconName: "FaGraduationCap",
      text: "Práctica profesional en Clínica de Atención Psicológica *(CAPS),* sede Providencia.",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Diplomado de postítulo* en *Psicoterapia Fenomenológica - Hermenéutica.* (Factual Chile).",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Diplomado de postítulo* en Convivencia Escolar en los Pilares de la Comunidad Educativa, (ProFuturo) con el respaldo de *MINEDUC.*",
    },
    {
      iconName: "FaGraduationCap",
      text: "Workshop: *“La práctica clínica en la terapia posracionalista”. *Doctor Juan Balbi.* Centro de Terapia Posracionalista (CETEPO, Chile).",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso Intensivo: *Estrategias para la Ansiedad en Psicoterapia,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso Intensivo: *Terapia de Pareja,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Trastornos de la Conducta Alimentaria,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Adolescencia, Vínculos y Convivencia Digital:* Claves para la comprensión, Centro de Educación Sexual Integral (CESI).",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Acoso Escolar: Prevención, Detección y Actuación,* ProFuturo.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Crisis y Terapia de Pareja,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Terapia Narrativa: Herramientas para el trabajo clínico,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Trauma emocional y quiebre vital,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *El duelo y la terapia. Abordaje clínico,* Factual Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Capacitación: *Diversidad e identidad de género,*OTD.",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Supervisión* constante de *casos clínicos,* participación de *reuniones clínicas,* *grupos de estudios* y *entrenamiento en el método de psicoterapia* con el que trabaja, Factual Chile.",
    },
  ],
};

export default matiasData;
